export const QuestionsType = {
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  SLIDER: 'SLIDER',
  SELECT: 'SELECT',
  TEXT: 'TEXT',
  RATING: 'RATING'
}

export const QuestionsAnswersStatus = {
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  APPROVED: 'APPROVED',
  REPROVED: 'REPROVED'
}
